<div class="circle mr-2" [style.backgrounColor]="color">
  <span *ngIf="!logo" class="name-initials">{{ name | nameInitials }}</span>
  <div
    *ngIf="logo"
    class="logo circle"
    style="background-image: url({{ logo }})"
  ></div>
</div>
